var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.469 14.8477C8.384 14.8477 9.938 16.4007 9.938 18.3167C9.938 20.2317 8.384 21.7847 6.469 21.7847C4.553 21.7847 3 20.2317 3 18.3167C3 16.4007 4.553 14.8477 6.469 14.8477Z",
    stroke: "#3A3B45",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0315 21.7847C16.1155 21.7847 14.5625 20.2317 14.5625 18.3157C14.5625 16.4007 16.1165 14.8477 18.0315 14.8477C19.9475 14.8477 21.5005 16.3997 21.5005 18.3157",
    stroke: "#3A3B45",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2502 3.28516C14.1652 3.28516 15.7192 4.83816 15.7192 6.75416C15.7192 8.66916 14.1652 10.2222 12.2502 10.2222C10.3342 10.2222 8.78125 8.66916 8.78125 6.75416",
    stroke: "#3A3B45",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddonIcon);
export default __webpack_public_path__ + "static/media/addon-icon.b7eb7b37318c2971eb3468c1c841d5aa.svg";
export { ForwardRef as ReactComponent };